import * as types from 'store/actions/types';
import produce from 'immer';

const INITIAL_STATE = {
	edit: {
		name: '',
		metadata: {
			author: '',
			description: '',
			source: '',
			title: ''
		}
	},
	isLoaded: true,
	error: false
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR ASSET GROUPS STATE ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// ****************** FETCH ASSET GROUP ******************
			case types.FETCH_ASSET_GROUP_LOADING:
				draft.isLoaded = false;
				return;

			case types.FETCH_ASSET_GROUP_SUCCESS:
				draft.edit = action.payload;
				draft.isLoaded = true;
				return;

			case types.FETCH_ASSET_GROUP_ERROR:
				draft.isLoaded = true;
				draft.error = true;
				return;

			default:
				return state;
		}
	});
